import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchRecords = ({settings}: StoreState) => settings.entity_types;

export const isEntityTypesFetching = createSelector(
    fetchRecords,
    ({ _isFetching }) => _isFetching
);

export const isEntityTypesPatching = createSelector(
    fetchRecords,
    ({ _isPatching }) => _isPatching
);

export const getEntityTypesByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
);

export const getEntityTypeById = createSelector(
    fetchRecords,
    (_, id) => id,
    ({ entities }, id) => entities?.[id]
);

export const getEntityTypesByEntityId = createSelector(
    fetchRecords,
    (_, id) => id,
    ({ entities, byEntityId }, id) => byEntityId?.[id]?.map(i => entities?.[i])
);

export const getEntityTypesByEntityIdAsObject = createSelector(
    fetchRecords,
    ({ byEntityId }) => byEntityId
)